module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan3-3-a60897831bf7b90cb1f138fb39d72f47.webp";